export default "__VITE_ASSET__CRrbISxY__"